// import React from 'react';

// const IconLogo = () => (
//   <svg id="logo" xmlns="http://www.w3.org/2000/svg" role="img" viewBox="0 0 84 96">
//     <title>Logo</title>
//     <g transform="translate(-8.000000, -2.000000)">
//       <g transform="translate(11.000000, 5.000000)">
//         <polygon
//           id="Shape"
//           stroke="currentColor"
//           strokeWidth="5"
//           strokeLinecap="round"
//           strokeLinejoin="round"
//           points="39 0 0 22 0 67 39 90 78 68 78 23"
//         />
//       </g>
//     </g>
//     <text x="27" y="65" fill="currentColor" fontSize="50px" fontFamily="Lucida Console">
//       P
//     </text>
//   </svg>
// );

// export default IconLogo;




// import React from 'react';

// const IconLogo = () => (
//   <svg
//     id="logo"
//     xmlns="http://www.w3.org/2000/svg"
//     role="img"
//     viewBox="0 0 100 100" // Increased and simplified viewBox for perfect scaling
//   >
//     <title>BK Logo</title>
//     <g transform="translate(5, 5)"> {/* Added padding to prevent stroke clipping */}
//       {/* Mathematically symmetrical 7-sided polygon (Heptagon) */}
//       <polygon
//         id="Shape"
//         stroke="currentColor"
//         strokeWidth="6" // Slightly thicker for a professional "infrastructure" feel
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         fill="none"
//         points="45,0 85.5,19.5 90,64.4 54.8,90 14.2,80.7 0,38.1 19.5,4.5"
//         transform="translate(0, 0)"
//       />
//       {/* "BK" Monogram perfectly centered */}
//       <text
//         x="45"
//         y="58"
//         fill="currentColor"
//         fontSize="26px"
//         fontFamily="Inter, system-ui, -apple-system, sans-serif"
//         fontWeight="800" // Extra bold looks better at small sizes
//         textAnchor="middle"
//         letterSpacing="-1px" // Tighter kerning makes it look like a designed logo
//       >
//         BK
//       </text>
//     </g>
//   </svg>
// );

// export default IconLogo;


// //by chatgpt

// import React from 'react';

// const IconLogo = () => {
//   // Function to generate perfect heptagon points
//   const generateHeptagonPoints = (cx, cy, r) => {
//     const points = [];
//     for (let i = 0; i < 7; i++) {
//       const angle = (2 * Math.PI * i) / 7 - Math.PI / 2; // Start from top
//       const x = cx + r * Math.cos(angle);
//       const y = cy + r * Math.sin(angle);
//       points.push(`${x},${y}`);
//     }
//     return points.join(' ');
//   };

//   const heptagonPoints = generateHeptagonPoints(50, 50, 45);

//   return (
//     <svg
//       id="logo"
//       xmlns="http://www.w3.org/2000/svg"
//       viewBox="0 0 100 100"
//       role="img"
//     >
//       <title>BK Logo</title>
//       <polygon
//         id="Shape"
//         stroke="currentColor"
//         strokeWidth="6"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         fill="none"
//         points={heptagonPoints}
//       />
//       <text
//         x="50"
//         y="55"             // Slightly adjusted to center vertically with bigger font
//         fill="currentColor"
//         fontSize="32px"     // Bigger font size
//         fontFamily="Inter, system-ui, -apple-system, sans-serif"
//         fontWeight="800"
//         textAnchor="middle"
//         letterSpacing="-1px"
//       >
//         BK
//       </text>
//     </svg>
//   );
// };

// export default IconLogo;



// //image logo
// import React from 'react';
// import myLogo from '../../images/logo.png'; // Make sure the path is correct

// const IconLogo = () => (
//   <img 
//     src={myLogo} 
//     alt="BK Logo" 
//     style={{ width: '100px', height: 'auto' }} 
//   />
// );

// export default IconLogo;


// import React from 'react';
// import myLogo from '../../images/logo.png';

// const IconLogo = () => (
//   <img 
//     src={myLogo} 
//     alt="BK Logo" 
//     style={{ width: '100%', height: 'auto' }} // Let the parent container define the size
//   />
// );

// export default IconLogo;


// import React from 'react';

// const IconLogo = () => (
//   <svg
//     id="logo"
//     xmlns="http://www.w3.org/2000/svg"
//     viewBox="0 0 1440 810"
//     role="img"
//     aria-label="BK Logo">
//     <title>BK Logo</title>
//     <g transform="translate(353, 47)">
//       {/* The Outer Frame */}
//       <path
//         stroke="currentColor"
//         strokeWidth="15"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//         fill="none"
//         d="M 367.148 7.144 L 78.542 146.136 L 7.246 458.257 L 206.917 708.75 L 527.191 708.75 L 726.863 458.257 L 655.562 146.136 Z"
//       />

//       {/* The BK Inner Text */}
//       <g fill="currentColor">
//         {/* K part */}
//         <path d="M 646.796 554.703 L 576.457 554.703 L 472.781 419.5 L 430.308 465.175 L 430.308 554.703 L 373.222 554.703 L 373.222 344.511 L 430.308 305.386 L 524.367 240.91 L 430.308 329.628 L 430.308 394.375 L 567.781 240.91 L 637.656 240.91 L 512.058 379.3 Z" />
//         {/* B part */}
//         <path d="M 316.492 309.007 C 344.355 293.929 360.792 271.554 360.792 239.582 C 360.792 193.921 322.429 161.031 268.082 161.031 L 114.152 161.031 L 114.152 474.808 L 149.375 474.808 L 87.472 536.425 L 177.371 474.808 L 249.339 425.484 L 170.792 425.484 L 170.792 335.957 L 262.589 335.957 C 293.402 335.957 315.207 354.382 315.566 380.093 L 362.273 348.07 C 352.445 332.144 336.773 318.773 316.492 309.007 Z M 254.378 289.367 L 170.792 289.367 L 170.792 210.355 L 254.378 210.355 C 282.242 210.355 302.328 226.792 302.328 250.093 C 302.328 272.933 282.23 289.367 254.378 289.367 Z" />
//       </g>
//     </g>
//   </svg>
// );

// export default IconLogo;


import React from 'react';

const IconLogo = () => (
  <svg
    id="logo"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 1440 810"
    role="img"
    aria-label="BK Logo">
    <title>BK Logo</title>
    <g transform="translate(353, 47)">
      
      {/* 1. The Dark Navy Background Shape */}
      <path 
        fill="#0f172a" 
        d="M 367.148438 7.144531 L 78.542969 146.136719 L 7.246094 458.257812 L 206.917969 708.75 L 527.191406 708.75 L 726.863281 458.257812 L 655.5625 146.136719 Z" 
      />

      {/* 2. The Bright Blue Outline (Heptagon) */}
      <path
        stroke="#38bdf8"
        strokeWidth="10"
        fill="none"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 367.148 7.144 L 78.542 146.136 L 7.246 458.257 L 206.917 708.75 L 527.191 708.75 L 726.863 458.257 L 655.562 146.136 Z"
      />

      {/* 3. The "K" part - Light Grey/White */}
      <path 
        fill="#f1f5f9" 
        d="M 646.796 554.703 L 576.457 554.703 L 472.781 419.5 L 430.308 465.175 L 430.308 554.703 L 373.222 554.703 L 373.222 344.511 L 430.308 305.386 L 524.367 240.91 L 430.308 329.628 L 430.308 394.375 L 567.781 240.91 L 637.656 240.91 L 512.058 379.3 Z" 
      />

      {/* 4. The "B" part - Bright Blue */}
      <path 
        fill="#38bdf8" 
        d="M 316.492 309.007 C 344.355 293.929 360.792 271.554 360.792 239.582 C 360.792 193.921 322.429 161.031 268.082 161.031 L 114.152 161.031 L 114.152 474.808 L 149.375 474.808 L 87.472 536.425 L 177.371 474.808 L 249.339 425.484 L 170.792 425.484 L 170.792 335.957 L 262.589 335.957 C 293.402 335.957 315.207 354.382 315.566 380.093 L 362.273 348.07 C 352.445 332.144 336.773 318.773 316.492 309.007 Z M 254.378 289.367 L 170.792 289.367 L 170.792 210.355 L 254.378 210.355 C 282.242 210.355 302.328 226.792 302.328 250.093 C 302.328 272.933 282.23 289.367 254.378 289.367 Z" 
      />
      
    </g>
  </svg>
);

export default IconLogo;